import { readContract, writeContract, waitForTransactionReceipt } from '@wagmi/core';
import { config } from './walletConfig';
import { abi } from './pro_mine_abi'; // 假設ABI導出名為 abi
import addresses from './addresses'; // 假設合約地址在這裡
import utils from '@/composables/utils';
// import Swal from 'sweetalert2';

// const { convertToWei, convertFromWei } = utils;

/**
 * 查詢合約常量 BLOCK_MINING_REWARD
 */
export async function getBlockMiningReward() {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'BLOCK_MINING_REWARD',
    args: []
  });
}

/**
 * 查詢合約常量 GENESIS_ALLOCATION_AMOUNT
 */
export async function getGenesisAllocationAmount() {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'GENESIS_ALLOCATION_AMOUNT',
    args: []
  });
}

/**
 * 查詢合約常量 MAX_MINING_BLOCKS
 */
export async function getMaxMiningBlocks() {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'MAX_MINING_BLOCKS',
    args: []
  });
}

/**
 * 查詢某地址累積挖礦
 */
export async function getAccumulatedMining(address) {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'accumulatedMining',
    args: [address]
  });
}

/**
 * 新增礦池
 */
export async function addMiningPool(userAddress, count) {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'addMiningPool',
    args: [userAddress, count]
  });
}

/**
 * 查詢boost等級
 */
export async function getBoostLevels(index) {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'boostLevels',
    args: [index]
  });
}

/**
 * 提升挖礦速度
 */
export async function boostMiningSpeed(userAddress, boostLevelIndex) {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'boostMiningSpeed',
    args: [userAddress, boostLevelIndex]
  });
}

/**
 * 查詢合約擁有者
 */
export async function getContractOwner() {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'contractOwner',
    args: []
  });
}

/**
 * 查詢當前挖礦產出
 */
export async function getCurrentMiningOutput(userAddress) {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'currentMiningOutput',
    args: [userAddress]
  });
}

/**
 * 查詢每區塊挖礦產出
 */
export async function getMiningPerBlock(userAddress) {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'getMiningPerBlock',
    args: [userAddress]
  });
}

/**
 * 查詢用戶礦池數量
 */
export async function getMiningPoolCount(userAddress) {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'getMiningPoolCount',
    args: [userAddress]
  });
}

/**
 * 查詢剩餘可挖產出
 */
export async function getRemainingMiningOutput(userAddress) {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'getRemainingMiningOutput',
    args: [userAddress]
  });
}

/**
 * 查詢總挖礦產出
 */
export async function getTotalMiningOutput(userAddress) {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'getTotalMiningOutput',
    args: [userAddress]
  });
}

/**
 * 查詢上次開始區塊
 */
export async function getLastStartBlock(address) {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'lastStartBlock',
    args: [address]
  });
}

/**
 * 查詢挖礦獎勵
 */
export async function getMiningReward() {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'miningReward',
    args: []
  });
}

/**
 * 查詢挖礦速度
 */
export async function getMiningSpeed(address) {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'miningSpeed',
    args: [address]
  });
}

/**
 * 查詢owner
 */
export async function getOwner() {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'owner',
    args: []
  });
}

/**
 * 放棄所有權
 */
export async function renounceOwnership() {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'renounceOwnership',
    args: []
  });
}

/**
 * 設置boost等級
 */
export async function setBoostLevels(levels) {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'setBoostLevels',
    args: [levels]
  });
}

/**
 * 設置合約擁有者
 */
export async function setContractOwner() {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'setContractOwner',
    args: []
  });
}

/**
 * 查詢startBlock
 */
export async function getStartBlock(address) {
  return await readContract(config, {
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'startBlock',
    args: [address]
  });
}

/**
 * 轉移所有權
 */
export async function transferOwnership(newOwner) {
  return await writeContract(config, {
    chainId: 137,
    abi,
    address: addresses.proMineContractAddress,
    functionName: 'transferOwnership',
    args: [newOwner]
  });
} 